(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/collections/payout-tables.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/collections/payout-tables.js');

'use strict';

svs.numbergames.results.collections.PayoutTables = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.results.models.PayoutTable
});

 })(window);